import React from 'react';

export const StackableContext = React.createContext<string | null>(null);

export function useStackableRouteId() {
  const context = React.useContext(StackableContext);
  if (!context) {
    console.error(
      'useStackableRouteId is being used outside of a StackableContext, this means you are rendering a StackScreen with no StackableContext'
    );

    return '';
  }
  return context;
}
